var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'do-drag': !_vm.composite }},[_c('div',{class:[_vm.composite ? 'composite-title' : 'survey-title'],style:({ color: _vm.color }),domProps:{"innerHTML":_vm._s(_vm.questionData.question[_vm.lang])}})])
}
var staticRenderFns = []

export { render, staticRenderFns }